// PrimeVue locale builder. 'en' uses PrimeVue defaults (plus first day Monday).
import { defaultOptions } from 'primevue/config'

const VI = {
  firstDayOfWeek: 1,
  dayNames: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
  dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  dayNamesMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
  monthNamesShort: ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9', 'T10', 'T11', 'T12'],
  today: 'Hôm nay',
  clear: 'Xóa',
  weekHeader: 'Tuần',
  dateFormat: 'dd/mm/yy',
  chooseDate: 'Chọn ngày',
  prevDecade: 'Thập kỷ trước',
  nextDecade: 'Thập kỷ sau',
  prevYear: 'Năm trước',
  nextYear: 'Năm sau',
  prevMonth: 'Tháng trước',
  nextMonth: 'Tháng sau',
  prevHour: 'Giờ trước',
  nextHour: 'Giờ sau',
  prevMinute: 'Phút trước',
  nextMinute: 'Phút sau',
  prevSecond: 'Giây trước',
  nextSecond: 'Giây sau',
  am: 'SA',
  pm: 'CH',
  accept: 'Có',
  reject: 'Không',
  choose: 'Chọn',
  upload: 'Tải lên',
  cancel: 'Hủy',
  completed: 'Hoàn tất',
  pending: 'Đang chờ',
  passwordPrompt: 'Nhập mật khẩu',
  weak: 'Yếu',
  medium: 'Trung bình',
  strong: 'Mạnh',
  apply: 'Áp dụng',
  addRule: 'Thêm điều kiện',
  removeRule: 'Xóa điều kiện',
  matchAll: 'Khớp tất cả',
  matchAny: 'Khớp bất kỳ',
  startsWith: 'Bắt đầu bằng',
  contains: 'Chứa',
  notContains: 'Không chứa',
  endsWith: 'Kết thúc bằng',
  equals: 'Bằng',
  notEquals: 'Khác',
  noFilter: 'Không lọc',
  lt: 'Nhỏ hơn',
  lte: 'Nhỏ hơn hoặc bằng',
  gt: 'Lớn hơn',
  gte: 'Lớn hơn hoặc bằng',
  dateIs: 'Là ngày',
  dateIsNot: 'Không là ngày',
  dateBefore: 'Trước ngày',
  dateAfter: 'Sau ngày',
  emptyFilterMessage: 'Không tìm thấy kết quả',
  emptyMessage: 'Không có dữ liệu',
  emptySelectionMessage: 'Chưa chọn mục nào',
  emptySearchMessage: 'Không tìm thấy kết quả',
  searchMessage: '{0} kết quả',
  selectionMessage: 'Đã chọn {0} mục',
  fileChosenMessage: '{0} tệp',
  noFileChosenMessage: 'Chưa chọn tệp',
  aria: {
    trueLabel: 'Đúng',
    falseLabel: 'Sai',
    nullLabel: 'Chưa chọn',
    star: '1 sao',
    stars: '{star} sao',
    selectAll: 'Đã chọn tất cả',
    unselectAll: 'Đã bỏ chọn tất cả',
    close: 'Đóng',
    previous: 'Trước',
    next: 'Sau',
    navigation: 'Điều hướng',
    scrollTop: 'Cuộn lên đầu',
    moveTop: 'Chuyển lên đầu',
    moveUp: 'Chuyển lên',
    moveDown: 'Chuyển xuống',
    moveBottom: 'Chuyển xuống cuối',
    moveToTarget: 'Chuyển sang đích',
    moveToSource: 'Chuyển về nguồn',
    moveAllToTarget: 'Chuyển tất cả sang đích',
    moveAllToSource: 'Chuyển tất cả về nguồn',
    pageLabel: 'Trang {page}',
    firstPageLabel: 'Trang đầu',
    lastPageLabel: 'Trang cuối',
    nextPageLabel: 'Trang sau',
    previousPageLabel: 'Trang trước',
    prevPageLabel: 'Trang trước',
    rowsPerPageLabel: 'Số dòng mỗi trang',
    jumpToPageDropdownLabel: 'Chuyển đến trang',
    jumpToPageInputLabel: 'Nhập số trang',
    selectRow: 'Đã chọn dòng',
    unselectRow: 'Đã bỏ chọn dòng',
    expandRow: 'Mở rộng dòng',
    collapseRow: 'Thu gọn dòng',
    showFilterMenu: 'Hiện bộ lọc',
    hideFilterMenu: 'Ẩn bộ lọc',
    filterOperator: 'Toán tử lọc',
    filterConstraint: 'Điều kiện lọc',
    editRow: 'Sửa dòng',
    saveEdit: 'Lưu',
    cancelEdit: 'Hủy sửa',
    listView: 'Dạng danh sách',
    gridView: 'Dạng lưới',
    slide: 'Trang chiếu',
    slideNumber: '{slideNumber}',
    zoomImage: 'Phóng to ảnh',
    zoomIn: 'Phóng to',
    zoomOut: 'Thu nhỏ',
    rotateRight: 'Xoay phải',
    rotateLeft: 'Xoay trái',
    listLabel: 'Danh sách lựa chọn',
    selectColor: 'Chọn màu',
    removeLabel: 'Xóa',
    browseFiles: 'Chọn tệp',
    maximizeLabel: 'Phóng to',
    minimizeLabel: 'Thu nhỏ'
  }
}

export function buildPrimeLocale(lang = 'vi') {
  if (lang === 'en') return { ...JSON.parse(JSON.stringify(defaultOptions.locale)), firstDayOfWeek: 1, dateFormat: 'dd/mm/yy' }
  return JSON.parse(JSON.stringify(VI))
}
